<div id="wrapper">
  <div class="nav-map" *ngIf="withOption">
    @if(isOnMobile){
    <div class="top-wrapper">
      <div>
        <input [(ngModel)]="params.search" class="form-control" [ngModelOptions]="{ standalone: true }"
          placeholder="Input Keyword" (keyup.enter)="geocodePostalCode()" />
      </div>
      <div>
        <button class="search" (click)="geocodePostalCode()" id="btnSearchGmap">
          <i class="fa-solid fa-search"></i>
        </button>
      </div>

    </div>

    }@else{

    <div>
      <label for="">Search Name</label>
      <input [(ngModel)]="params.search" class="form-control" [ngModelOptions]="{ standalone: true }"
        placeholder="Input Keyword" (keyup.enter)="geocodePostalCode()" />
    </div>
    <div>
      <label for="">Postal</label>
      <input [(ngModel)]="params.postalCode" class="form-control" ngDefaultControl placeholder="Enter Postalcode" />
    </div>
    <div>
      <label for="">Radius</label>
      <select class="form-control form-select" (change)="handleZoom()" [(ngModel)]="params.radius">
        <option value="0" selected disabled>Radius</option>
        <option *ngFor="let radius of [0.2, 1, 2, 5, 10, 20, 'All']" [value]="radius">
          {{ radius == 'All' ? 'All' : radius < 1 ? radius * 1000 + "m" : radius + "km" }} </option>
      </select>
    </div>
    <div>
      <button class="search" (click)="geocodePostalCode()" id="btnSearchGmap">
        <i class="fa-solid fa-search"></i>
      </button>
    </div>


    }


  </div>

  <!-- Start of Selection -->
  <button class="btn btn-secondary w-100 mb-2 d-block d-md-none" (click)="showMap = !showMap" *ngIf="isOnMobile">
    <i [ngClass]="showMap ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
    {{ showMap ? 'Hide Maps' : 'Show Maps' }}
  </button>


  <div class="map-params my-2" [ngClass]="{ 'd-none d-md-block': !showMap }" *ngIf="isOnMobile">
    <div>
      <label for="">Postal</label>
      <input [(ngModel)]="params.postalCode" class="form-control" ngDefaultControl placeholder="Enter Postalcode" />
    </div>
    <div>
      <label for="">Radius</label>
      <select class="form-control form-select" (change)="handleZoom()" [(ngModel)]="params.radius">
        <option value="0" selected disabled>Radius</option>
        <option *ngFor="let radius of [0.2, 1, 2, 5, 10, 20, 'All']" [value]="radius">
          {{ radius == 'All' ? 'All' : radius < 1 ? radius * 1000 + "m" : radius + "km" }} </option>
      </select>
    </div>
  </div>



  <!-- End of Selection -->

  <!-- Start of Selection -->
  <!-- Start of Selection -->

  <div id="map" [ngClass]="{ 'd-none d-md-block': !showMap }"></div>
</div>